<template>
  <div class="cons-listy">
    <div class="content-s" v-if="info.banner_list && info.banner_list.length > 0">
      <van-swipe class="my-swipe" :autoplay="2000" indicator-color="white">
        <van-swipe-item v-for="item in info.banner_list" :key="item.id">
          <img :src="item.img_cover" alt />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div
      class="content-s enterpriseInfo"
      v-if="url != 'jnlx.yijiudingdong.com' && url != 'test-yj-01.dongguajie.cn'"
    >
      <div class="title">公司简介</div>
      <div class="infoONcte" v-html="info.description"></div>
    </div>
    <div
      class="n_comint"
      v-if="url == 'jnlx.yijiudingdong.com' || url == 'test-yj-01.dongguajie.cn'"
    >
      <video width="100%" height="100%" controls class="n_margtop" v-if="videos" :poster="videoImg">
        <source :src="videos" type="video/mp4" v-if="videos != ''" />
        <!-- <source :src="videos" type="video/ogg" />您的浏览器不支持Video标签。 -->
      </video>
      <img :src="imgPath + item" alt v-for="(item,index) in imgList" :key="index" />
    </div>
    <!-- <div class="content-s enterpriseInfo">
      <div class="user-scical space-between">
        <div class="flex">
          <div class="userImg" v-if="info.card">
            <img :src="info.card.head_photo" alt />
          </div>
          <div>
            <div class="name">{{info.shop_name}}</div>
            <div class="subName">欢迎点击右侧按钮咨询交流</div>
          </div>
          <div>
            <span class="iconfont icondianhua21" @click="callPhone" v-if="info.mobile"></span>
            <span class="iconfont iconweixin1"></span>
          </div>
        </div>
      </div>
      <div class="log_im space-between" @click="goGaodeFg">
        {{info.area}}
        <span class="iconfont iconjiantouarrow591"></span>
      </div>
    </div>-->
    <div class="n_height"></div>
  </div>
</template>

<script>
import share from '../../public/share.js'
import wx from 'weixin-js-sdk'
import { analysisUrl } from '../../public/public.js'
export default {
  name: 'website',
  data() {
    return {
      info: {},
      cardHead: '',
      url: '',
      imgList: [
        'yj_gwt_01.jpg',
        'yj_gwt_02.jpg',
        'yj_gwt_03.jpg',
        'yj_gwt_04.jpg',
        'yj_gwt_05.jpg',
        'yj_gwt_06.jpg',
        'yj_gwt_07.jpg',
        'yj_gwt_08.jpg',
        'yj_gwt_09.jpg',
        'yj_gwt_10.jpg',
      ],
      videos:
        'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/voice/public/yj20210902171121.mp4',
    }
  },
  created() {
    this.getUrl()
    this.url = localStorage.getItem('domain')
    this.getInfo()
    this.cardHead = localStorage.getItem('cardHead')
  },
  mounted() {
    if (this.$store.state.shareStr != 'website') {
      new share(
        {
          startUrl: window.location.href,
        },
        this.$store,
        'website'
      )
    } else {
      this.shareModelFg()
    }
  },
  watch: {
    // imgUrl(val, oldval) {
    //监听到imgUrl有变化以后 说明新图片已经生成 隐藏DOM
    // this.$refs.box.style.display = 'none'
    // },
    '$store.state.shareStr': function (e) {
      if (e == 'website') {
        this.shareModelFg()
      }
    },
  },
  methods: {
    getUrl() {
      let urk = analysisUrl(window.location.href)
      localStorage.setItem('shareInfo', JSON.stringify(urk))
      if (urk.type == 'share' && !JSON.parse(localStorage.getItem('isToken'))) {
        this.$store.commit('LoginFailure', true)
      }
      if (urk.type == 'share' && JSON.parse(localStorage.getItem('isToken'))) {
        this.shareExtensionFg(urk)
      } else if (JSON.parse(localStorage.getItem('shareInfo')).uid) {
        this.shareExtensionFg(JSON.parse(localStorage.getItem('shareInfo')))
      }
    },
    //分享关系
    async shareExtensionFg(obj) {
      let res = await this.http('Client.shareExtension', {
        share_member_id: obj.uid,
        share_staff_id: obj.share_staff_id || 0,
        scenes: obj.scenes,
      })
      localStorage.setItem('shareId', res.content.share_sign_no)
      // 查看是否有红包
      if (res.content.share_sign_no) {
        this.receiveShareRedPacket(res.content.share_sign_no)
      }
      console.log(res)
    },
    // 领取分享新用户得红包  有分享关系请求
    receiveShareRedPacket(id) {
      this.http('MemberRedPacket.receiveShareRedPacket', {
        share_sign_no: id,
      }).then((e) => {
        console.log(e)
      })
    },
    shareModelFg() {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?type=share' +
        '&uid=' +
        uid +
        '&scenes=website'
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })
      let shareInfo = {
        title: '壹玖叮咚_您身边的名酒专家_好酒尽在壹酒叮咚~~',
        desc: '让每个老百姓都喝得起品质好酒',
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
        imgUrl:
          'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yi_logo.jpg',
      }
      wx.onMenuShareAppMessage(shareInfo)
      wx.onMenuShareTimeline(shareInfo)
    },
    async getInfo() {
      let res = await this.http('WebIndex.webIndex', {})
      this.info = res.content
      console.log(res)
    },
    // 跳转高德
    goGaodeFg() {
      if (this.info.area) {
        window.location.href = `https://uri.amap.com/marker?position=${this.info.lat},${this.info.lng}&name=${this.info.area}`
      }
    },
    // 拨打电话
    callPhone() {
      window.location.href = 'tel://' + this.info.mobile
    },
  },
}
</script>
<style scoped>
.van-swipe-item img {
  width: 100%;
  height: 100%;
}
.n_height {
  height: 200px;
}
.icondianhua21 {
  margin-right: 10px;
}
.icondianhua21 {
  font-size: 64px;
}
.iconweixin1 {
  font-size: 64px;
}
.cons-listy {
  background: #f7f8fa;
  min-height: 100vh;
  padding-top: 1px;
}
.content-s {
  width: 710px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 20px;
  overflow: hidden;
}
.my-swipe {
  height: 320px;
  background: red;
}
.enterpriseInfo {
  background: #ffffff;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 20px;
}
.enterpriseInfo .title {
  position: relative;
  line-height: 36px;
  padding-left: 10px;
}
.enterpriseInfo .title::before {
  content: '';
  width: 6px;
  height: 36px;
  background: #d8d8d8;
  position: absolute;
  left: 0;
  top: 0px;
}
.infoONcte {
  padding-top: 20px;
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #474747;
  line-height: 60px;
}
.space-between {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.user-scical .flex {
  height: 100px;
  align-items: center;
}
.user-scical .userImg {
  width: 100px;
  height: 100px;
  background: #d8d8d8;
  margin-right: 20px;
  border-radius: 20px;
}
.userImg img {
  width: 100px;
  height: 100px;
  border-radius: 20px;
}
.user-scical .name {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  color: #000000;
  line-height: 42px;
}
.user-scical .subName {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  width: 400px;
  line-height: 42px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.log_im {
  padding: 24px 20px;
  background: rgba(247, 248, 250, 1);
  margin-top: 20px;
  align-items: center;
}
.iconjiantouarrow591 {
  font-size: 42px;
  color: #ccc;
}
.n_comint {
  margin-top: 20px;
}
.n_comint img {
  width: 100%;
}
</style>